//@ts-nocheck
import { GetScriptsOutput } from '../../types'

export function getScripts(
  scripts: object,
  provider: 'ndr' | 'rga',
  payer: boolean,
  userRole: 'screener' | 'fronter' | 'closer' | '*',
  lang: 'en' | 'es' = 'en',
): GetScriptsOutput {
  //@ts-ignore
  return scripts[
    `${lang}_${userRole === '*' ? '' : `${userRole.toLowerCase()}_`}${payer ? 'payer' : 'nonpayer'}_${provider}`
  ]
}
